import React from "react";
import { motion } from "framer-motion";
import "./Coreservices.css";

import softwareImg from "../LandingPage/posimagemaamaas.jpg";
import cloudImg from "../LandingPage/tablenewpos.jpg";
import digitalImg from "../LandingPage/inventry.jpg";

const sections = [
  {
    title: "POS BILLING",
    desc: "A powerful and easy-to-use POS billing system designed for restaurants, cafés, and food businesses. It enables fast order processing, accurate GST billing, and seamless checkout to improve customer experience and reduce billing time.",
    points: [
      "Fast Billing",
      "GST Invoice",
      "Discount Management",
      "Customer Billing History",
    ],
    img: softwareImg,
    impact: "Reduce billing time by 50% and improve customer satisfaction",
  },
  {
    title: "SALES MANAGEMENT",
    desc: "Track, analyze, and optimize your restaurant's sales performance with a smart sales management system. Gain real-time insights into revenue, daily sales, and promotions to make better business decisions.",
    points: [
      "Daily Sales Reports",
      "Sales Analytics Dashboard",
      "Revenue Tracking",
      "Offer & Promotion Management",
    ],
    img: softwareImg,
    impact: "Increase revenue by 30% with data-driven decisions",
  },
  {
    title: "ORDER MANAGEMENT",
    desc: "Efficiently manage dine-in, takeaway, and online orders through a centralized order management system. Ensure accurate order flow between waiters, kitchen staff, and billing for faster service.",
    points: [
      "Order Tracking",
      "Kitchen Order Ticket (KOT)",
      "Waiter Order Taking",
      "Real-time Order Updates",
    ],
    img: cloudImg,
    impact: "Reduce order errors by 40% and speed up service",
  },
  {
    title: "TABLE MANAGEMENT",
    desc: "Simplify restaurant table operations with smart table management tools. Monitor table availability, manage reservations, and handle split billing to improve seating efficiency and customer service.",
    points: [
      "Table Reservation",
      "Table Status Monitoring",
      "Split Bills",
      "Table Billing",
    ],
    img: cloudImg,
    impact: "Increase table turnover rate by 25%",
  },
  {
    title: "INVENTORY MANAGEMENT",
    desc: "Keep full control over your restaurant inventory by tracking ingredients, stock usage, and purchase records. Automated alerts help prevent stock shortages and reduce wastage.",
    points: [
      "Ingredient Tracking",
      "Low Stock Alerts",
      "Stock Usage Reports",
      "Vendor Management",
    ],
    img: digitalImg,
    impact: "Reduce food wastage by 35% and save costs",
  },
  {
    title: "CHEF MANAGEMENT",
    desc: "Improve kitchen productivity with a structured chef management system. Assign tasks, manage recipes, and track kitchen workflow to ensure timely food preparation and consistent quality.",
    points: [
      "Recipe Management",
      "Chef Task Assignment",
      "Kitchen Workflow Tracking",
      "Preparation Reports",
    ],
    img: digitalImg,
    impact: "Improve kitchen efficiency by 45%",
  },
  {
    title: "DELIVERY MANAGEMENT",
    desc: "Manage restaurant delivery operations smoothly with real-time tracking and delivery partner management. Ensure orders reach customers quickly and maintain a reliable delivery experience.",
    points: [
      "Delivery Partner Management",
      "Delivery Tracking",
      "Customer Address Management",
      "Delivery Reports",
    ],
    img: softwareImg,
    impact: "Reduce delivery time by 20%",
  },
  {
    title: "CATERING MANAGEMENT",
    desc: "Handle catering events and bulk food orders efficiently with a dedicated catering management system. Organize event orders, manage customer requirements, and track catering performance.",
    points: [
      "Event Order Management",
      "Bulk Orders Handling",
      "Customer Event Details",
      "Catering Performance Reports",
    ],
    img: softwareImg,
    impact: "Manage 50% more catering events efficiently",
  },
];

const Feature = () => {
  return (
    <section className="hrps-wrapper">

      {/* Background Image */}
      <div className="hrps-bg"></div>

      <div className="hrps-container">

        {/* Heading */}
        <div className="hrps-main-heading">
          <h2>
            OUR POS <span>  FEATURES </span>
          </h2>
          <div className="hrps-line"></div>
        </div>

        {/* Sections */}
        {sections.map((item, index) => (
          <motion.div
            key={index}
            className={`hrps-section ${index % 2 !== 0 ? "reverse" : ""}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >

            {/* Content */}
            <div className="hrps-content">
              <h3>{item.title}</h3>

              <p className="hrps-desc">{item.desc}</p>

              <ul className="hrps-list">
                {item.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>

              <p className="hrps-impact">
                <strong>Business impact:</strong> {item.impact}
              </p>
            </div>

            {/* Image */}
            <div className="hrps-image">
              <img src={item.img} alt={item.title} />
            </div>

          </motion.div>
        ))}

      </div>

      {/* Wave Divider */}
      <div className="pfb-wave-divider">
        <svg viewBox="0 0 1440 120" preserveAspectRatio="none">
          <path d="M0,60 C240,120 480,0 720,60 C960,120 1200,0 1440,60 L1440,120 L0,120 Z"></path>
        </svg>
      </div>

    </section>
  );
};

export default Feature;